import { api } from './_httpClient'
import { persistor } from '../store'

const authenticate = async (payload) =>
  api.post('/user/authenticate', payload)

const resetAuthData = () => persistor.purge()

export { authenticate, resetAuthData }
